import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { environment } from '../../../../environments/environment';
import { ThemeService } from '../../services/theme.service';
import { MenuService } from '../../services/menu.service';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  imports: [TegelModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  readonly theme = inject(ThemeService);
  private readonly menu = inject(MenuService);
  private readonly user = inject(UserService);
  private readonly auth = inject(AuthService);

  appName = 'CLOCKLOAD' + environment.envSuffix;

  username = this.user.username;
  useremail = this.user.useremail;
  userphoto = this.user.userphoto;

  mobileMenuAction(): void {
    this.menu.setSignal(true);
  }

  toggleTheme(): void {
    this.theme.toggle();
  }

  logout(): void {
    this.auth.logout();
  }
}
